import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { FontWeight, PRESSABLE } from '../../../../../styles/constants';
import { Button as BaseButton } from '../../../../Button/Button';
import { LoginButton } from '../../../../CorporateGroupIdentity/LoginButton/LoginButton';

export const IdentityProviderModalButton = styled(BaseButton)`
  ${PRESSABLE};
  align-items: center;
  background-color: ${ThemeColours.primary700};
  border: solid 1px ${ThemeColours.white};
  border-radius: 16px;
  box-sizing: border-box;
  color: ${ThemeColours.white};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 32px;
  justify-content: center;
  margin-top: 24px;
  padding: 0 16px;
  text-decoration: none;
  width: unset;

  &:hover {
    background-color: ${ThemeColours.white};
    color: ${ThemeColours.primary700};
  }
`;

export const IdentityProviderContinueButton = styled(LoginButton)`
  ${PRESSABLE}
  border: 2px solid ${ThemeColours.mono200};
  color: ${ThemeColours.black};
  font-size: 16px;
  margin: 16px 0;
  padding: 0px 24px;
  width: 300px;

  &:hover {
    background: ${ThemeColours.mono100};
  }
`;

export const IdentityProviderLoginButton = styled(LoginButton)`
  ${PRESSABLE};
  align-items: center;
  background-color: ${ThemeColours.primary700};
  border: solid 1px ${ThemeColours.white};
  border-radius: 16px;
  box-sizing: border-box;
  color: ${ThemeColours.white};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 32px;
  justify-content: center;
  margin-top: 24px;
  padding: 0 16px;
  text-decoration: none;
  width: unset;

  &:hover {
    background-color: ${ThemeColours.white};
    color: ${ThemeColours.primary700};
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  min-height: 0;
  overflow: hidden;
`;
